<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Project_document_types/elements/Title.vue'

export default {
  name: 'DocumentTypeForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
